import { createRoot } from 'react-dom/client';
import { AnalyticsProvider } from 'use-analytics';

import GraceWrapper from 'components/common/GraceWrapper';
import PackWrapper from 'components/common/PackWrapper';
import pixelAnalytics from 'helpers/analytics/pixelAnalytics';
import { getStore } from 'store/configure';

const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#hc_grace_react_app');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store}>
      <AnalyticsProvider
        instance={pixelAnalytics({
          canTrack: rootElement?.getAttribute('data-can-track') === 'true',
        })}
      >
        <GraceWrapper />
      </AnalyticsProvider>
    </PackWrapper>
  );
});
